import { BusinessEntityType } from '@grc/ui-shared/lib/components/models/enums/enums';
import { getBusinessEntities } from './get-business-entities';

interface FetchBusinessEntitiesParams {
  fetchData: any;
  entityIds: string[];
  setData?: (data: any) => void;
  entityType?: BusinessEntityType;
  status?: boolean;
}

export const fetchBusinessEntities = async ({
  fetchData,
  entityIds,
  setData,
  entityType = BusinessEntityType.AccountSupplier,
  status = true
}: FetchBusinessEntitiesParams) => {
  if (!entityIds.length) return {};

  const res = await getBusinessEntities(fetchData, {
    status,
    locationIds: entityIds
  });

  const items: any[] = Array.isArray(res) ? res : [];

  if (setData && items.length > 0) {
    setData(items[0]);
  }

  const map: any = {};
  for (const e of items) {
    const key = e?.id ?? e?.Id;
    if (key) map[key] = e;
  }

  return {
    items,
    map,
    firstItem: items[0]
  };
};
